import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../hooks';

export type BookingUpdateState = {
  canceledBookingId: string;
};

const initialState: BookingUpdateState = {
  canceledBookingId: '',
};

export const bookingUpdateSlice = createSlice({
  name: 'bookingUpdate',
  initialState,
  reducers: {
    setCanceledBookingId: (state, action: PayloadAction<string>) => {
      state.canceledBookingId = action.payload;
    },
  },
});

export const useBookingUpdateState = () => {
  const dispatch = useAppDispatch();

  const canceledBookingId = useAppSelector(
    (state) => state.bookingUpdate.canceledBookingId,
  );

  const setCanceledBookingId = (newCanceledBookingId: string) => {
    dispatch(
      bookingUpdateSlice.actions.setCanceledBookingId(newCanceledBookingId),
    );
  };

  return {
    canceledBookingId,
    setCanceledBookingId,
  };
};
